import { Clickable, Col, Icon, Row, Text } from 'components';
import { theme } from 'lib';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { calculateCost } from '../../../lib';

const SpanText = styled.span`
  font-size: 18px;
  color: ${theme.GREY_60};
  font-weight: 400;
`;

const UserItem = (props) => {
  const { user, excludeIds, type, pricing, discounts, handleRemove, recurring, foundCurrency } =
    props;

  const { currency } = useSelector((state) => state.user.billing),
    { t } = useTranslation(),
    totalCost = calculateCost({ pricing, discounts, user }, currency, type, recurring),
    originalPrice = pricing[currency].price * (recurring === 'annual' ? 12 : 1),
    hasDiscount = totalCost < originalPrice;

  return (
    <Row noFlex ht="40px" center marg="0 0 12px">
      <Col>
        <Text>
          {type === 'bundle' ? t('subscribe.bundleSquad', { name: user.name }) : user.name}
        </Text>
        {type === 'bundle' && (
          <Text b2 col={theme.GREY_60}>
            {t('subscribe.numberAthletes', {
              amount: (user?.athletes?.length || 0) - excludeIds.length
            })}
          </Text>
        )}
      </Col>

      <Row noFlex center>
        <Col noFlex>
          {totalCost ? (
            <Text h5>
              <SpanText>{foundCurrency.symbol}</SpanText>
              {(totalCost / 100)
                .toLocaleString(undefined, {
                  style: 'currency',
                  currency: currency || 'usd'
                })
                .slice(1)}
            </Text>
          ) : (
            <Text h5>{t('common.free')}</Text>
          )}

          {hasDiscount && (
            <Text
              col={theme.GREY_60}
              align="right"
              style={{
                textDecorationLine: 'line-through',
                textDecorationStyle: 'solid'
              }}
            >
              {(originalPrice / 100).toLocaleString(undefined, {
                style: 'currency',
                currency: currency || 'usd'
              })}
            </Text>
          )}
        </Col>

        <Clickable marg="0 0 0 12px" onClick={() => handleRemove(user)}>
          <Icon type="close" dimensions={14} col={theme.GREY_60} />
        </Clickable>
      </Row>
    </Row>
  );
};

export default UserItem;
